import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Code,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { importFile, useExportTemplateMutation, useQueryGetListScript } from 'services/category';
import { CookieStorage } from 'utils/cookie-storage';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { FileExcelValid, ModalType, ROOT_API } from 'constants/common';
import SizeTable from './components/Table';
import CreateCategoryModal from './components/CreateScriptModal';
import Pagination from 'components/Pagination/Pagination';
import { downloadFile } from 'utils/helpers';
import { toast } from 'components/Toast';
import { CopyIcon } from '@chakra-ui/icons';

function Script() {
  const textColor = useColorModeValue('gray.700', 'white');
  const history = useHistory();
  const [sizeEditing, setSizeEditing] = useState(null);
  const [searchTitle, setSearchTitle] = useState('');
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const exportTemplateMutation = useExportTemplateMutation();
  const inputImportRef = useRef();

  useEffect(() => {
    if (!CookieStorage.isAuthenticated()) {
      return history.push('/auth/sign-in');
    }
  }, []);

  const { isOpen: isCreateModalOpen, onOpen: onOpenCreateModal, onClose: onCloseCreateModal } = useDisclosure();
  const { isOpen: isChangeStatusModalOpen, onOpen: onOpenChangeStatusModal, onClose: onCloseChangeStatusModal } = useDisclosure();
  const openModal = useMemo(
    () => ({
      [ModalType.Add]: onOpenCreateModal,
      [ModalType.ChangeStatus]: onOpenChangeStatusModal,
    }),
    [onOpenCreateModal, onOpenChangeStatusModal]
  );
  const closeModal = useMemo(
    () => ({
      [ModalType.Add]: onCloseCreateModal,
      [ModalType.ChangeStatus]: onCloseChangeStatusModal,
    }),
    [onCloseCreateModal, onCloseChangeStatusModal]
  );

  const { data: categoryData, refetch } = useQueryGetListScript(
    { ...filter, searchKeyword: filter.searchTitle },
    { enabled: CookieStorage.isAuthenticated() }
  );

  const handleUpdateItem = (size, modalType) => {
    openModal?.[modalType]?.();
    setSizeEditing(size);
  };

  const handelCloseModal = modalType => {
    closeModal?.[modalType]?.();
    setSizeEditing(null);
  };

  const handleSearch = () => {
    setFilter({
      ...filter,
      searchTitle: searchTitle,
    });
  };

  const handleReset = () => {
    setFilter({
      pageIndex: 0,
      pageSize: 10,
    });
    setSearchTitle('');
  };

  // const onDownloadTemplate = () => {
  //   exportTemplateMutation.mutate(undefined, {
  //     onSuccess: response => {
  //       downloadFile(response, 'category-template');
  //       toast.showMessageSuccess('Tải mẫu shortlink thành công');
  //     },
  //     onError: () => {
  //       toast.showMessageError('Tải mẫu shortlink thất bại');
  //     },
  //   });
  // };

  // const handleImportFileExcel = async e => {
  //   if (e?.target?.files?.[0]) {
  //     const file = e.target.files[0];
  //     const extensionFile = file?.name?.split('.')?.pop();

  //     if (FileExcelValid.includes(extensionFile)) {
  //       const formData = new FormData();

  //       formData.append('importFile', file);

  //       await importFile(formData)
  //         .then(() => {
  //           toast.showMessageSuccess('Tải lên danh sách shortlink thành công');
  //           refetch();
  //         })
  //         .catch(() => {
  //           toast.showMessageError('Tải lên danh sách shortlink thất bại');
  //         });

  //       return;
  //     }

  //     setError('Chỉ hỗ trợ tải lại file định dạng .xlsx, xls');
  //   }
  // };

  // const handleDeleteAllRecord = () => {
  //   if (window.confirm('Bạn có chắc chắn muốn xóa tất cả các shortlink?')) {
  //     // deleteCategoryMutation.mutate(
  //     //   { id: category?._id },
  //     //   {
  //     //     onSuccess: () => {
  //     //       toast.showMessageSuccess('Xóa tất cả các shortlink thành công');
  //     //       refetch?.();
  //     //     },
  //     //     onError: () => {
  //     //       toast.showMessageError('Xóa tất cả các shortlink không thành công');
  //     //       refetch?.();
  //     //     },
  //     //   }
  //     // );
  //   }
  // };

  return (
    <Flex direction="column" pt={{ base: '120px', md: '75px', lg: '100px' }}>
      <Card p="16px" mb="24px" bg="#fff">
        <CardHeader p="12px 5px" mb="12px">
          <Flex justifyContent={'space-between'}>
            <Flex direction={'column'}>
              <Flex direction="column" gap={'30px'}>
                <Text fontSize="xl" color={textColor} fontWeight="bold">
                  Copy script trên chèn vào header của file html
                </Text>
                <Flex alignItems={"center"} gap={4}><Code fontStyle={"italic"} fontSize={20}>{`<script type="text/javascript" src="https://adda.link/api/v1/ads/invoke"></script>`}</Code>
                <CopyIcon cursor={"pointer"} _hover={{
                  boxSize: 7,
                }} boxSize={25} onClick={() => navigator.clipboard.writeText(`<script type="text/javascript" src="${ROOT_API}/api/v1/ads/invoke"></script>`)}/></Flex>
              </Flex>
            </Flex>
            
          </Flex>
        </CardHeader>
      </Card>
      {isCreateModalOpen && (
        <CreateCategoryModal categorysDetail={sizeEditing} isOpen={isCreateModalOpen} onClose={handelCloseModal} refetch={refetch} />
      )}
    </Flex>
  );
}

export default Script;
